import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TweenLite} from "gsap";
import {ThorGameConfig} from "../../ThorGameConfig";
import {ThorSoundConfig} from "../../ThorSoundConfig";
import {ThorPromoPanelConfig} from "../../ThorPromoPanelConfig";

/**
 * Created by Jerker Nord on 2019-07-02.
 */

export class ThorScatterNearWinView extends BaseView {

    private static NEAR_WIN_ANIMATION_NAME:string = "ScatterReel";
    private static SPINE_ASSET_NAME:string = "scatterReel";

    private _reelPositions:PIXI.Point[] = [new PIXI.Point(299, 322), new PIXI.Point(470, 322), new PIXI.Point(640, 322), new PIXI.Point(810, 322), new PIXI.Point(980, 322)];
    private _scatterNearWinAnimations:PIXI.spine.Spine[];
    private _scatterNearWinAnimationTweens:SpineTween[];
    private _layer:ScalableLayer;
    private _highestNearWinReel:number;
    private _enableTL:TimelineLite;
    private _disableTL:TimelineLite;

    constructor() {
        super();
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.WIN_COUNT_UP.name);
        this._layer.addChild(this);
        this._scatterNearWinAnimations = [];
        this._scatterNearWinAnimationTweens = [];
    }

    protected initAnimations():void {
        for(let i:number = 0; i < 5; i++) {
            let scatterNearWinAnimation:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(ThorScatterNearWinView.SPINE_ASSET_NAME));
            scatterNearWinAnimation.position = this._reelPositions[i];
            scatterNearWinAnimation.alpha = 0;
            this.addChild(scatterNearWinAnimation);
            this._scatterNearWinAnimations.push(scatterNearWinAnimation);
            this._scatterNearWinAnimationTweens.push(new SpineTween(scatterNearWinAnimation, 0, ThorScatterNearWinView.NEAR_WIN_ANIMATION_NAME, -1));
        }

        for(let i:number = 0; i < 5; i++) {
            this._scatterNearWinAnimationTweens[i].kill();
        }
    }

    public enableScatterAnimation(reel:number, playSound:boolean = true):void {
        if(!ThorPromoPanelConfig.scatterNearWinFlag){
            return;
        }
        if(this._enableTL && this._enableTL.isActive()) {
            this._enableTL.pause();
            this._enableTL.kill();
        }
        this._enableTL = new TimelineLite();
        this._enableTL.add([
            () => this._scatterNearWinAnimationTweens[reel].restart(),
            () => new TweenLite(this._scatterNearWinAnimations[reel], 0.2, {alpha : 1}),
            () => this.playSoundEffect(playSound)
        ]);
        this._highestNearWinReel = reel;
    }

    private playSoundEffect(play:boolean):void {
        if(play) {
            SlotGame.sound.playEffect(ThorSoundConfig.instance.NEAR_WIN_START);
        }
    }

    public disableScatterAnimation(reel:number,durr:number=0.2):void {
        if(this._scatterNearWinAnimations[reel]?.alpha > 0) {
            if(this._disableTL && this._disableTL.isActive()) {
                this._disableTL.pause();
                this._disableTL.kill();
            }
            this._disableTL = new TimelineLite();
            this._disableTL.add(() => new TweenLite(this._scatterNearWinAnimations[reel], durr, {alpha : 0}));
            this._disableTL.add(() => this._scatterNearWinAnimationTweens[reel].kill());

            if(reel == this._highestNearWinReel) {
                SlotGame.sound.stopEffect(ThorSoundConfig.instance.NEAR_WIN_START);
                SlotGame.sound.playEffect(ThorSoundConfig.instance.NEAR_WIN_STOPP);
            }
        }
    }
}